module.exports = __webpack_public_path__ + "media/images/hezbollah-bg-section-771bcf414ad48e16a0615c897ac57253.jpg";